'use strict';

import paypal from 'public/js/components/paypal';
import paypalSmartButtons from 'public/js/components/paypal-smart-buttons/index';

const flyoutLoadingCallback = (show) => {
	if (show) {
		rp$('body').overlaySpinner();
	} else {
		rp$('body').overlaySpinner.remove();
	}
};

const initPaypalButtons = () => {
	rp$('.cart-listing').on('click', '.paypal-button', (e) => {
		paypal.doPaypalCheckout(e);
	});

	const paypalFlyoutContainerClass = '.paypal-smart-flyout-button';
	if (!document.querySelector(paypalFlyoutContainerClass)) {
		return;
	}

	const flyoutButtonOpts = { loadingCallback: flyoutLoadingCallback };

	// standard PayPal only when RP Payments is enabled. initSmartButtons here would
	// race initFlyoutPaypalButtons and can restore Venmo/Pay Later after cart AJAX remounts.
	if (globalThis.rp_app?.env?.rp_payments?.enabled) {
		paypalSmartButtons.initPaypalButton(paypalFlyoutContainerClass, flyoutButtonOpts);
		return;
	}

	paypalSmartButtons.initSmartButtons(paypalFlyoutContainerClass, flyoutButtonOpts);
};

export default {
	initPaypalButtons,
};
